import { useNavigate, useParams } from "react-router-dom";
import { useGetChallengeById } from "../../api/useProducts/useChallenges";
import { useEffect } from "react";
import { Sidebar } from "../../components";
import Loader from "../../components/Loader";
import WorkOutsCard from "../../components/WorkOutsCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import moment from "moment";

const ChallengeDetail = () => {
  const { challengeId } = useParams();
  const { challengesData, challengesLoading, challengesRefetch } =
    useGetChallengeById(Number(challengeId));
  const navigate = useNavigate();
  useEffect(() => {
    challengesRefetch();
  }, [challengeId]);
  const breadcrumbItems = [
    { title: "Challenges", link: "challenges" },
    { title: "Detail " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      {challengesLoading ? (
        <div className="h-[80vh] flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className=" mt-3">
          {/* Challenge Image */}
          <h1 className="text-2xl font-semibold mb-3">
            {challengesData?.title}
          </h1>

          {challengesData?.image && (
            <div className="mb-6">
              <img
                src={challengesData?.image}
                alt={challengesData?.title}
                className=" border w-full max-h-96 rounded-2xl shadow-lg object-cover"
              />
            </div>
          )}
          <div className="border-b-2 flex">
            <span className="border-b-[3.5px] border-darkCyan ms-4 font-medium px-3 pb-2 translate-y-[2px]">
              Overview
            </span>
          </div>

          <div className="mt-5 space-y-2 border-b-2 pb-4">
            <p>
              <span className="font-medium">Points:</span>{" "}
              {challengesData?.points || "N/A"}
            </p>
            <p>
              <span className="font-medium">Type:</span>{" "}
              {challengesData?.type || "N/A"}
            </p>
            <p>
              <span className="font-medium">Target Days:</span>{" "}
              {challengesData?.target_days || "N/A"}
            </p>
            {challengesData?.image_evidence && (
              <p>
                <span className="font-medium">Image Evidence:</span>{" "}
                {"True"}
              </p>
            )}
            {challengesData?.text_evidence && (
              <p>
                <span className="font-medium">Text Evidence:</span>{" "}
                {"True"}
              </p>
            )}
            {challengesData?.steps && (
              <p>
                <span className="font-medium">Steps:</span>{" "}
                {challengesData?.steps}
              </p>
            )}
            {challengesData?.pts && (
              <p>
                <span className="font-medium">Pts:</span>{" "}
                {challengesData?.pts}
              </p>
            )}
            {/* <p>
              <span className="font-medium">Start Date:</span>{" "}
              {moment(challengesData?.startDate).format("YYYY-MM-DD") || "N/A"}
            </p>
            <p>
              <span className="font-medium">End Date:</span>{" "}
              {moment(challengesData?.endDate).format("YYYY-MM-DD") || "N/A"}
            </p> */}
          </div>

          {/* Description Section */}
          {challengesData?.description && (
            <div className="mt-6">
              <h3 className=" font-medium">Description</h3>
              <br />
              <div className=" text-base">
                <div
                  className=""
                  dangerouslySetInnerHTML={{
                    __html: challengesData?.description,
                  }}
                />
              </div>
            </div>
          )}

          <h3 className="  my-6">Workouts</h3>
          {/* Workouts Section */}
          {challengesData?.workouts && challengesData?.workouts?.length > 0 ? (
            <div className="">
              <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 mt-3">
                {challengesData?.workouts.map((workout) => (
                  <div
                    key={workout?.workoutId}
                    className="mb-8 cursor-pointer"
                    onClick={() =>
                      navigate(`/workouts/detail/${workout?.workout?.id}`)
                    }
                  >
                    <WorkOutsCard
                      description={workout?.workout?.description}
                      imageUrl={workout?.workout?.media}
                      title={workout?.workout?.title}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <img
                src="/images/workouts-not-found.png"
                className="w-40 h-40"
                alt="image not found"
              />
              <p className="text-lg font-semibold text-[#D9D9D9]">
                No workout right now!
              </p>
            </div>
          )}

          <h3 className=" mb-4">Users</h3>
          {challengesData?.userChallenges &&
          challengesData?.userChallenges?.length > 0 ? (
            <div className="">
              <div className="flex flex-wrap gap-3">
                {challengesData?.userChallenges.map((user, idx) => {
                  return (
                    <div className=" text-center">
                      <img
                        src={user.user.profile_image || "/images/profile.jpg"}
                        alt="image not found"
                        className="w-20 h-20 rounded-xl object-cover border"
                      />
                      <p
                        title={user?.user?.fullName}
                        className="text-sm truncate overflow-hidden whitespace-nowrap max-w-[80px]"
                      >
                        {user?.user?.fullName}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <img
                src="/images/user-not-found.png"
                className="w-32 h-32"
                alt="image not found"
              />
              <p className="text-lg font-semibold text-[#D9D9D9]">
                No User right now!
              </p>
            </div>
          )}
        </div>
      )}
    </Sidebar>
  );
};

export default ChallengeDetail;
